import Vue from 'vue'
import Vuex from 'vuex'
import permission from "./modules/permission";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      enName: '',
      cnName: "",
      scrollNavBgStatus: false,
  },
  mutations: {
      changePageTitle(state, pageName){
          state.cnName = pageName == "improve_information" ? "译员注册" : "个人主页";
          state.enName = pageName == "improve_information" ? "Interpreter registration" : "Personal home page";
          if(pageName=="improve_information"||pageName=="modify_information"){
              state.scrollNavBgStatus = true;
          }else {
              state.scrollNavBgStatus = false
          }
      },
      scrollInTop(state, value){
          state.scrollNavBgStatus = value
      }
  },
  actions: {
  },
  modules: {
      permission
  },
    // 定义全局getters 方便访问是否为已注册译员状态
    getters:{
        isInterpreter: state => state.permission.isInterpreter,
        selfInfo: state => state.permission.selfInfo
    }
})
